import { useCallback, useState } from 'react';

import { VirtualCreditCard } from '~/components/VirtualCreditCards/virtualCreditCards.types';

import OffersService from '~/services/OffersService';

export const useReserveVirtualCreditCardsForCustomOffer = (customOfferId) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const [virtualCreditCards, setVirtualCreditCards] = useState<Array<VirtualCreditCard>>([]);

  const reserveVirtualCreditCardsForCustomOffer = useCallback(async () => {
    try {
      setError(null);
      setIsLoading(true);
      const response = await OffersService.reserveVirtualCreditCardsForCustomOffer(customOfferId);
      setVirtualCreditCards(response.result);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'An error occurred');
    } finally {
      setIsLoading(false);
    }
  }, [customOfferId]);

  return { isLoading, error, virtualCreditCards, reserveVirtualCreditCardsForCustomOffer };
};
